/* Copyright (c) 2018 NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Provider, APP_INITIALIZER } from '@angular/core';

import { AppConfig, BaseConfigType } from './app.config';

export function loadAppConfig<ConfigType extends BaseConfigType>(
    appConfig: AppConfig<ConfigType>
): () => Promise<ConfigType> {
    return () => appConfig.load().toPromise();
}

export const AppConfigLoader: Provider = {
    provide: APP_INITIALIZER,
    useFactory: loadAppConfig,
    multi: true,
    deps: [AppConfig]
};

export function loadConfiguration<ConfigType extends BaseConfigType>(appConfig: AppConfig<ConfigType>) {
    return appConfig.get();
}

export function defaultConfigurationProvider<ConfigType extends BaseConfigType>(config: ConfigType): Provider {
    return {
        provide: config,
        useFactory: loadConfiguration,
        deps: [AppConfig]
    };
}
